// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_WEAR_PARTS_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updateWearPartsClaimPin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_PIN
});

export const updateWearPartsClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_ONE,
    workOrder
});

export const updateWearPartsClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_TWO,
    workOrder
});

export const updateWearPartsClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_OWNERSHIP_STATUS
});

export const updateWearPartsClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FAILURE_PART
});

export const updateWearPartsClaimFailureRemanIndicator = remanIndicator => ({
    remanIndicator,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_REMAN_INDICATOR
});

export const updateWearPartsClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FAILURE_DATE
});

export const updateWearPartsClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_REPAIR_DATE
});

export const updateWearPartsClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateWearPartsClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT
});

export const updateWearPartsClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetWearPartsClaim = () => ({
    type: actions.RESET_CLAIM_WEAR_PARTS
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_WEAR_PARTS_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/claim-details.js